import { batch } from 'react-redux';
import { Response } from 'express';

import { doRequest } from '@r1-frontend/do-request';
import { getInfoAll } from '@r1-frontend/api-domru/api-profile/v2/info/all';
import { ResponseContactDto } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { getAgreementNumber } from '@r1-frontend/shared/helpers/getAgreementNumber';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

import { TAppThunkDispatch, TGetState } from '~/src/store';
import {
    setClientContacts,
    setClientInfoStage,
    setClientPayment,
    setClientPersonal,
    setClientProducts,
    setErrorClientPayment,
    setFetchClientPayment,
} from '~/src/store/actionCreators/auth';
import { logout } from '~/src/store/actions/auth/logout';
import { EStage, IClientContacts } from '~/src/store/reducers/auth';

import selectProviderId from '../selectors/selectProviderId';

export const parseContacts = (_contacts: ResponseContactDto['contacts']): IClientContacts => {
    const { contacts } = _contacts;
    return {
        email: contacts.email.map((el) => ({
            ...el,
            value: el.contactValue,
        })),
        phone: contacts.phone.map((el) => ({
            ...el,
            value: el.contactValue,
        })),
    };
};


/**
 * Информация о клиенте
 */
/** @deprecated use frontend/apps/b2c-domru/src/store/actions/auth/getInfoAll.ts **/
export const fetchClientInfo = (response?: Response, agreementNumber?: string) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState) => {
        const state = getState();

        const providerId = selectProviderId(state);
        const accessToken = state.auth.accessToken;
        const isFetching = state.auth.clientPaymentFetching;
        const agreement = agreementNumber || getAgreementNumber();

        if (!providerId || !accessToken || isFetching) {
            return;
        }

        dispatch(setFetchClientPayment(true));
        // актуальные статусы
        dispatch(setClientInfoStage({
            payment: EStage.loading,
            contacts: EStage.loading,
            products: EStage.loading,
            personal: EStage.loading,
        }));

        const resp = await doRequest.apiProfile<ResponseContactDto>(
            getInfoAll(providerId, accessToken, agreement, ['personal', 'payment', 'products', 'contacts']),
        );

        if (resp.isSuccess) {
            const { personal, payment, products, contacts } = resp.payload;

            batch(() => {
                dispatch(setClientPersonal(personal));
                dispatch(setClientPayment(payment));
                dispatch(setClientProducts(products));
                dispatch(setClientContacts(parseContacts(contacts)));
                dispatch(setClientInfoStage({
                    payment: EStage.loaded,
                    contacts: EStage.loaded,
                    products: EStage.loaded,
                    personal: EStage.loaded,
                }));
            });
        } else {
            if (resp.error.code.toString() === '401') {
                dispatch(logout(response));
                return;
            }

            if (isServerSide()) {
                console.log(JSON.stringify({ event: 'Ошибка при вызове getInfoAll', ...resp.error }));
            }
        }

        dispatch(setErrorClientPayment(false));
    };
};
